import createResource from './createResource';

const telehealthsResources = createResource<any>({
  key: 'telehealths',
  url: '/telehealths',
});

export default telehealthsResources;
